<template>
  <section id="lineaServicios">
    <div class="row max-width-md section-title">
      <div class="col-12">
        <h1>Conócenos un poco más</h1>
        <p>
          TORBEL es una empresa especializada en el diseño y ejecución de
          proyectos de infraestructura visual, sistemas de iluminación LED y
          asesoría en gestión ambiental dirigida a empresas y grupos
          corporativos.
        </p>
      </div>
    </div>
    <div class="services" :class="{ 'visible-content': show }">
      <!-- First Service -->
      <article class="services__line">
        <div class="services__line__preview">
          <img
            class="services__line__preview__img"
            src="/images/pic-infraestructura-2.png"
          />

          <div class="services__line__preview__title">
            <img
              alt="Icono Infraestructura Visual"
              src="../../../assets/images/ic-infraestructura.png"
              class="services__line__preview__title__icon"
            />
            <h5 class="services__line__preview__title__text">
              Infraestructura Visual
            </h5>

            <a v-on:click="toggle" class="services__line__preview__title__link">
              Ver más
            </a>
          </div>
        </div>

        <transition name="fade">
          <section class="services__line__content" v-if="show">
            Realizamos el diseño, suministro e instalación de letreros
            exteriores luminosos para proyectos e instalaciones existentes.
            Trabajamos para empresas nacionales y multinacionales cuyos
            estándares responden a calidad mundial en alianza con la empresa
            Neón Nieto de Costa Rica.
          </section>
        </transition>
      </article>
      <!-- ./First Service -->

      <!-- Second Service -->
      <article class="services__line">
        <div class="services__line__preview">
          <img
            class="services__line__preview__img"
            src="/images/pic-iluminacion3.png"
          />
          <div class="services__line__preview__title">
            <img
              alt="Icono Sistemas de Iluminación LED"
              src="../../../assets/images/ic-iluminacion.png"
              class="services__line__preview__title__icon"
            />
            <h5 class="services__line__preview__title__text">
              Sistemas de Iluminación LED
            </h5>

            <a v-on:click="toggle" class="services__line__preview__title__link">
              Ver más
            </a>
          </div>
        </div>

        <transition name="fade">
          <section v-if="show" class="services__line__content">
            <p>
              Proveemos soluciones de iluminación LED, en alianza con empresas
              norteamericanas de calidad mundial, realizando los diseños,
              especificaciones y suministro de luminarias, en proyectos
              comerciales e industriales, incluyendo proyectos en ambientes
              severos y de alto riesgo.
            </p>
          </section>
        </transition>
      </article>
      <!-- ./Second Service -->

      <!-- Third Service -->
      <article class="services__line">
        <div class="services__line__preview">
          <img
            class="services__line__preview__img"
            src="/images/pic-ambiental-home.jpg"
          />
          <div class="services__line__preview__title">
            <img
              alt="Icono Sistemas de Iluminación LED"
              src="../../../assets/images/ic-gestion-ambiental.png"
              class="services__line__preview__title__icon"
            />
            <h5 class="services__line__preview__title__text">
              Asesoría en Gestión Ambiental
            </h5>

            <a v-on:click="toggle" class="services__line__preview__title__link">
              Ver más
            </a>
          </div>
        </div>

        <transition name="fade">
          <section v-if="show" class="services__line__content">
            <p>
              Realizamos estudios ambientales para nuevos proyectos e
              instalaciones existentes, para asegurar el cumplimiento de la
              normativa ambiental del Ministerio de Medio Ambiente.
            </p>
            <p>Nuestro servicio de asesoría ambiental incluye:</p>
            <ul>
              <li>
                Informes de Cumplimientos Ambientales (ICA’s) para estaciones
                existentes
              </li>
              <li>
                Mediciones de niveles de contaminantes de aire, ruido y agua
              </li>
              <li>
                Gestión de permisología ambiental en el Ministerio de Medio
                Ambiente
              </li>
              <li>
                Informes de Análisis de Riesgos para el Ministerio de Industria
                y Comercio
              </li>
              <li>
                Plan de Seguridad y Salud para certificación del Ministerio de
                Trabajo (PSST)
              </li>
            </ul>
          </section>
        </transition>
      </article>
      <!-- ./Third Service -->
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionServicios',
  data() {
    return {
      show: false,
    };
  },
  created() {
    this.checkRoute();
  },
  watch: {
    $route() {
      this.checkRoute();
    },
  },
  methods: {
    toggle: function () {
      this.show = !this.show;
    },
    checkRoute() {
      if (this.$route.path === '/linea-servicio') {
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.services {
  display: flex;
  a {
    color: $gray;
  }
  a:hover {
    text-decoration: none;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }

  &__line {
    position: relative;
    flex: 1;

    @media (max-width: 767px) {
      flex-direction: column;
    }

    &__preview {
      cursor: default;

      &__img {
        width: 100%;
      }

      &__title {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1.5rem 2rem;
        text-align: center;
        flex-direction: column;

        &__icon {
          margin: 10px 0;
          height: 54px;
        }

        &__link {
          font-size: 14px;
          font-weight: 500;
          text-align: center;
          color: $gray;

          &:hover {
            color: $gray;
          }
        }
      }
    }

    &__content {
      display: flex;
      justify-content: center;
      margin: 10px 0;
      padding: 1rem 2rem;
      flex-direction: column;
      justify-content: center;
      font-size: $extra-small-font-size;
      transition: background-color 0.5s;

      p {
        height: auto;
      }

      ul {
        padding-left: 20px;
      }
    }

    &:hover {
      color: $gray;
    }
  }
}

.visible-content {
  .services__line__preview__title {
    padding: 1rem 2rem 0rem 2rem;
  }

  .services__line__content {
    padding-top: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
